import { Form } from '@unform/web';
import { addMinutes, isAfter, isBefore, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';
import SelectSimple from '../../../../../../components/Forms/SelectSimple';
import { useLoading } from '../../../../../../hooks/LoadingHook';
import { useModal } from '../../../../../../hooks/Modal';
import api from '../../../../../../services/api';
import { date, dateLanguageDate } from '../../../../../../utils/date';
import Input from '../../../../../DashboardPages/core/components/Forms/Input';

interface IOptions {
    text?: string;
    label?: string;
    value: string;
}


interface IProps {
    
    setCallback: Function;
    student?: Record<string,any>;

}

const UpdateStudent: React.FC<IProps> = ({ student, setCallback }) => {
    const { addLoading, removeLoading } = useLoading();
    const { addModal, removeModal } = useModal();
 

 

    const updateData = async (data) => {

        if (!data?.name) {
            addModal({ title: '', theme: 'whiteModalMini', content: <p style={{ color: '#333', fontSize: '12px' }}>Informe o nome do aluno</p> })
            return
        }

        if (!data?.document_type) {
            addModal({ title: '', theme: 'whiteModalMini', content: <p style={{ color: '#333', fontSize: '12px' }}>Informe o tipo de documento do aluno</p> })
            return
        }
        if (!data?.rg) {
            addModal({ title: '', theme: 'whiteModalMini', content: <p style={{ color: '#333', fontSize: '12px' }}>Informe o documento do aluno</p> })
            return
        }


        addLoading({ title: 'Realizando agendamento', key: 'loading' }); 
       
        try {
            await api.put(`/update-visitation-student/${student?.user_hash}`, data)

            removeModal('atualizar-aluno');
            setCallback();
            removeLoading('loading');
        }
        catch (err) {
            addModal({ title: '', theme: 'whiteModalMini', content: <p style={{ color: '#333', fontSize: '12px' }}>{err?.response?.data?.message || err?.response?.data?.error || 'Erro ao atualizar aluno'}</p> })
            removeLoading('loading');
        }

    }

    return (
        <>
            <Form onSubmit={updateData} initialData={ { document_type : student?.document_type || 'CPF', name: student?.name, rg : student?.rg }}>

              <Input name='name' placeholder='Nome'/>
              <SelectSimple name='document_type' label='Tipo de documento' options={[
                {label: 'CPF', value: 'CPF'},
                {label: 'RG', value: 'RG'},
                {label: 'CN', value: 'CN'}


              ]}/>
              <Input name='rg' placeholder='Nº do Documento'/>
 <div className='row pad-sm full-width'>
              <button className='defaultButtonMini purpleContent'>Salvar</button>
</div>
            </Form>

        </>
    );
};
export default UpdateStudent;
